import { type ReactNode, useEffect, useMemo, useState } from "react";
import { IconContext } from "react-icons";
import { FaFileAudio } from "react-icons/fa6";
import { PiPlayCircleFill } from "react-icons/pi";

import { Modal } from "@src/components/Modal";

import { useMeuPlayState } from "@src/states/meuplay";
import { usePlayerState } from "@src/states/player";

import { player } from "@src/services/player";
import { playerOverlays } from "@src/services/playerOverlays";

import { createImage } from "@src/utils/createImage";

import "./style.less";
import type { AudiosOnDemandProps } from "./types";

let preloadedAudios = "";

export function AudiosOnDemand({ radio }: AudiosOnDemandProps) {
  const [isOpen, setIsOpen] = useState(false);
  const audios = useMemo(
    () => (radio.audios || []).filter((audio) => !audio.cron),
    [radio],
  );

  const didPong = useMeuPlayState((state) => state.didPong);
  useEffect(() => {
    if (!didPong) return;
    const urls = audios.map((audio) => audio.url);
    const _preloadedAudios = JSON.stringify({ idRadio: radio.name, urls });
    if (urls.length > 0 && _preloadedAudios !== preloadedAudios) {
      preloadedAudios = _preloadedAudios;
      console.log("[AudiosOnDemand] Preloading audios:", urls);
      player.preloadAudios(radio.name, urls);
    }
  }, [didPong, audios, radio.name]);

  const renderList: ReactNode =
    audios.length === 0 ? (
      <p className="empty">Nenhum áudio não agendado disponível.</p>
    ) : (
      audios.map((item) => {
        const image = createImage(item.name);
        return (
          <div
            key={item.id}
            className="audio clickable"
            onClick={() => {
              playerOverlays.playOnDemand({
                url: item.url,
                onStart: () => {
                  setIsOpen(false);
                  usePlayerState.setState({
                    currentTrackId: "onDemand",
                    currentTrack: {
                      artist: "Áudio não agendado",
                      title: item.name,
                      artwork_small: image,
                      artwork_large: image,
                    },
                  });
                },
                onEnded: () => {
                  console.log("onDemand ended");
                },
              });
            }}
          >
            <img src={image} alt={item.name} />
            <IconContext.Provider
              value={{ color: "#ff5510", className: "icon", size: "4em" }}
            >
              <PiPlayCircleFill className="play" />
            </IconContext.Provider>
            <div className="text">{item.name}</div>
          </div>
        );
      })
    );

  return (
    <>
      <IconContext.Provider
        value={{ color: "#ffffff", className: "icon", size: "1.5em" }}
      >
        <div
          className="AudiosOnDemand-component clickable"
          onClick={() => setIsOpen(true)}
          data-tooltip-id="footer"
          data-tooltip-content={"Áudios\nnão agendados"}
          data-tooltip-class-name="text-center"
          data-tooltip-place="top"
        >
          <FaFileAudio />
        </div>
      </IconContext.Provider>
      <Modal
        className="AudiosOnDemand-modal"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      >
        <h2>Áudios não agendados</h2>
        <hr />
        <div className="list">{renderList}</div>
      </Modal>
    </>
  );
}
